import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledSkeletonLoaderContainer = styled.div`
  padding: ${toRem(16)};

  .image-place-loader {
    display: block;
    height: ${toRem(655)};
    width: 100%;
  }

  @media ${baseVariables.mediaQuery.md} {
    padding: ${toRem(16)} ${toRem(90)};

    .image-place-loader {
      height: 100%;
    }
  }
`;
